import Cookies from "js-cookie";

// Components
import AppSidebar from "@/components/layout/AppSidebar";
import Navbar from "@/components/layout/Navbar";
import Main from "@/components/layout/Main";
import Footer from "@/components/layout/Footer";

// import CookieBanner from "@/components/global/CookieBanner";
import { Toaster } from "@/components/common/sonner";

// Features
import TitleUpdater from "@/components/global/TitleUpdater";

// Providers
import { SidebarProvider } from "@/components/common/sidebar";

//Contexts
import { AppFiltersProvider } from "@/contexts/AppFilters";

function App() {
  const defaultOpen = Cookies.get("sidebar_state") === "true";

  return (
    <>
      <AppFiltersProvider>
        <TitleUpdater />
        <SidebarProvider defaultOpen={defaultOpen}>
          <AppSidebar />
          <div className="flex min-h-full w-full flex-col">
            <Main>
              <Navbar />
            </Main>
            <Footer />
            {/* <CookieBanner /> */}
            <Toaster richColors />
          </div>
        </SidebarProvider>
      </AppFiltersProvider>
    </>
  );
}

export default App;
